export default __webpack_public_path__ + "images/EMETEBE.dd8d44b.png";